import { apiClient } from '@/services/ApiClient.js'

export default {
  getCities() {
    return apiClient
      .get('cities')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
